import { createStore } from 'effector';

export const $images = createStore<Map<string, string>>(new Map());
